export default "__VITE_ASSET__BHNchApo__"